import gql from 'graphql-tag';
import { ProductAttributeOptionAllData } from '../fragments';

export default gql`
mutation deleteProductAttributeOption (
    $id: ID!
) {
    deleteProductAttributeOption (id: $id) {
        ...ProductAttributeOptionAllData
    }
}
${ProductAttributeOptionAllData}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/deleteProductAttributeOption.ts